@use "foundation/colors";
@use "foundation/responsive";
@use "./shared" as shared;

.pro_feature_check {
  @include shared.screen-container;
  text-align: unset;
}

.description {
  @include shared.description;
  max-width: 608px;
  text-align: center;
  color: colors.$primary-eerie-black;
}

.feature_card {
  background-color: rgba(34, 34, 34, 0.05);
  border-radius: 16px;
  padding: 28px 24px 24px;
  width: 535px;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 40px;

  @include responsive.phone {
    width: 100%;
  }
}

.feature_card_title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.1;
  color: colors.$primary-eerie-black;
  margin: 0;

  @include responsive.phone {
    font-size: 18px;
  }
}

.feature_list {
  list-style: none;
  padding: 0;
  margin: 16px 0 32px 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 0 2px;

    svg {
      flex-shrink: 0;
      margin-top: 2px;
    }

    span {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.3;
      color: colors.$primary-eerie-black;
    }
  }
}

.keep_plan_button {
  width: 100% !important;
  height: 101px !important;
  font-size: 32px !important;

  @include responsive.phone {
    height: 54px !important;
    font-size: 16px !important;
  }
}

.continue_link {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: colors.$primary-eerie-black;
  cursor: pointer;
  text-decoration: none !important;
  margin-top: 40px;

  &:hover {
    text-decoration: underline;
  }
}
